import { c as _c } from "react/compiler-runtime";
export default function SuperRareIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="tw-w-full tw-h-full d-flex align-items-center tw-align-top" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="white" transform="scale(1.11) translate(0, 2.78)" d="M63.1425 1.07814H18.0228L0 20.1097L40.4829 67.9671L80.9661 20.1097L63.1425 1.07814ZM19.6455 20.1097L31.4951 7.358H58.4084L70.258 20.1097L45.0178 50.2227L19.6455 20.1097Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}